module.exports = "https://p.cds.unp.clasificados.pe/bg-vehiculos.22da90c7b10d4f91dca4015704272615.jpg";